export default class Address {

	constructor() {
		this.postalCode = "";
        this.state = "";
        this.city = "";
        this.street = "";
        this.number = "";
        this.complement = "";
        this.country = "";
        this.neighborhood = "";
        this.googleAddress = "";
	}
}